import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getProductSheets: builder.query({
      query: () => ({ url: 'customer/product/product-sheet' }),
    }),
    getPricelists: builder.query({
      query: () => ({ url: 'customer/product/pricelist' }),
    }),
    getTermsAndConditions: builder.query({
      query: () => ({ url: 'customer/product/terms-and-conditions' }),
    }),
    getPricelistData: builder.query({
      query: ({ location }) => ({ url: location }),
    }),
    getCoverage: builder.query({
      query: ({ page, size, ...params }) => ({
        url: 'customer/plans/coverage',
        params: { page, page_size: size, ...params },
      }),
    }),
  }),
});

const initialState = {
  coverage: { isLoading: false, data: [] },
  pricelists: { isLoading: false, data: [] },
  pricelistDetails: { isLoading: false, data: [] },
  productSheets: { isLoading: false, data: [] },
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {},
  extraReducers: (builder) => builder,
});

export default productSlice.reducer;
